var ErrorRouterService = function ($q) {
    var currentSubscriberId = -1;
    var subscribers = [];

    /* check any match of @value to @listOfRules and return true in that case */
    function matchAny(listOfRules, value) {
        function matchOne(a, b) {
            if (a == '*') return true;
            if (b == '*') return true;
            return a == b;
        };
        return listOfRules.filter(function (e) { return matchOne(e, value) }).length > 0;
    }

    function patternMatch(p1, p2) {
        return !['method', 'status', 'resourceName'].map(function (p) {
            if (!p1[p]) p1[p] = ['*'];
            if (!p2[p]) p2[p] = ['*'];
            p1[p] = [].concat(p1[p]);
            p2[p] = [].concat(p2[p]);

            return p1[p]
                .map(function (e) { return matchAny(p2[p], e); })
                .filter(function (e) { return e }).length > 0;
        }).filter(function (e) {
            return !e;
        }).length > 0;

    }

    //subscribe
    //
    //@param {function :: Error -> Promise<boolean>} - handler returning false if error has not handled  
    //
    //@pattern {object} - pattern description to match error
    //
    //@return {number} - current subscriber id
    //
    //@description
    //Subscribes listener on error notification.
    function subscribe(handler, pattern) {
        //check if handler is a function
        if (typeof handler !== 'function') {
            throw new Error('Handler has to be a function');
        };
        //create new subscriber
        var subscriber = {
            //handlerId: ++currentSubscriberId,
            id: ++currentSubscriberId,
            handler: handler,
            pattern: pattern
        };
        //add subscriber into collection
        subscribers.push(subscriber);
        //return new subscriber id
        return subscriber.id;
    };
    //unsubscribe
    //
    //@param {number} - id
    //
    //@return {boolean} - true if unsubscribe was successful
    //
    //@description
    //Unsubscribes listener with given id
    function unsubscribe(id) {
        var initialLength = subscribers.length;
        //exclude subscriber with given id from the collection
        subscribers = subscribers.filter(function (el) {
            return el.id !== id;
        });
        //check if the subscriber was excluded from the collection
        return initialLength !== subscribers.length;
    };


    //route
    //
    //@err {object} - error 
    //@pattern {object} - error id (see errors.js constants file for details)
    //
    //@description
    //Match and Notifies all subscribers about error event.
    //@return Promise<boolean> Return False if at least one of subscribers returned true 
    //if there are no listeners we consider this situation like a generic error
    function route(err, pattern) {
        return $q.all(subscribers
            .filter(function (e) { return patternMatch(e.pattern, pattern); })
            .map(function (el) {
                return el.handler.call(null, err);
            })).then(function (arr) {
                return arr.length ? !arr.filter(function (e) { return e !== true }).length > 0 : false;
            });

    };

    //factory methods
    return {
        subscribe: subscribe,
        unsubscribe: unsubscribe,
        route: route
    }
};
ErrorRouterService.$inject = ['$q'];

module.exports = ErrorRouterService;
